import React from 'react';
import { ClientDealTable } from '@/components/tables/ClientDealTable';

export const DebtorsTab = () => {
	return <ClientDealTable pipeline={process.env.REACT_APP_PIPELINE_DEBTORS} />;
};
DebtorsTab.displayName = 'DebtorsTab';
